import { ArrowRight, Volume2, Mic, Globe } from "lucide-react";
import { t } from "@/lib/i18n";
import { useReveal } from "@/hooks/useReveal";
import { ClaraAvatar } from "./Brand";

const POINTS = ["ai.step1", "ai.step2", "ai.step3", "ai.step4"];

export const ClaraSection = ({ onOpenChat }) => {
  const [ref, inView] = useReveal();
  return (
    <section id="clara" ref={ref} data-testid="clara-section" className="relative scroll-mt-16 overflow-hidden">
      <span className="ac-rings -left-48 top-10 h-[600px] w-[600px]" />
      <div className={`ac-reveal ${inView ? "is-in" : ""} relative mx-auto grid max-w-[1300px] items-center gap-12 px-4 py-24 sm:px-8 lg:grid-cols-2 lg:py-32`}>
        <div>
          <p className="ac-eyebrow">{t("clara.kicker")}</p>
          <h2 className="mt-5 font-wide text-4xl font-normal leading-[1.05] text-ac-ink sm:text-5xl">{t("clara.title")}</h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-ac-muted">{t("clara.desc")}</p>
          <div className="mt-6 flex flex-wrap gap-2 text-xs text-ac-muted">
            {[[Globe, "ES · EN · FR"], [Mic, t("voice.start")], [Volume2, t("msg.listen")]].map(([I, l]) => (
              <span key={l} className="flex items-center gap-1.5 rounded-full border border-ac-line px-3 py-1.5"><I className="h-3.5 w-3.5 text-ac-primary" /> {l}</span>
            ))}
          </div>
          <button data-testid="clara-section-cta" onClick={onOpenChat} className="ac-pill ac-pill-solid mt-10">{t("cta.btn")} <ArrowRight className="h-4 w-4" /></button>
        </div>
        <div className="relative rounded-3xl border border-ac-line bg-ac-surface p-8 backdrop-blur-xl">
          <div className="flex items-center gap-4">
            <ClaraAvatar size="h-16 w-16" ring="border-ac-surface" />
            <div>
              <p className="font-mark text-2xl font-bold text-ac-ink">Clara</p>
              <p className="ac-eyebrow !text-[11px]">{t("clara.badge")}</p>
            </div>
          </div>
          <p className="mt-6 rounded-2xl rounded-tl-sm border border-ac-line bg-ac-surface2 p-4 text-sm leading-relaxed text-ac-text">{t("ai.hello")}</p>
          <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.16em] text-ac-faint">{t("ai.intro").replace(/:.*/, "")}</p>
          <div className="mt-3 space-y-2">
            {POINTS.map((p, i) => (
              <div key={p} className="flex items-center gap-3 rounded-full border border-ac-line px-4 py-2.5 text-sm font-semibold text-ac-ink">
                <span className="font-mono text-xs text-[color:var(--ac-eyebrow)]">0{i + 1}</span> {t(p)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export const FinalCta = ({ onOpenChat }) => {
  const [ref, inView] = useReveal();
  return (
    <section ref={ref} data-testid="final-cta" className="relative overflow-hidden border-t border-ac-line">
      <span className="ac-rings left-[calc(50%-350px)] top-[calc(50%-350px)] h-[700px] w-[700px]" />
      <div className={`ac-reveal ${inView ? "is-in" : ""} relative mx-auto max-w-[1300px] px-4 py-28 text-center sm:px-8 lg:py-36`}>
        <h2 className="font-mark text-[clamp(2.4rem,7vw,6rem)] font-extrabold uppercase leading-[0.9] text-ac-ink">
          {t("cta.t1")}<br /><span className="ac-grad-text">{t("cta.t2")}</span>
        </h2>
        <button data-testid="final-cta-button" onClick={onOpenChat} className="ac-pill ac-pill-solid mt-12">{t("cta.btn")} <ArrowRight className="h-4 w-4" /></button>
      </div>
    </section>
  );
};
